import { userService } from '../_services';

export function authHeader() {
    // return authorization header with jwt token
	/* when storing to localstorage then it stored as a string, when we need to retrieve then we need to parse it get the object */
	
    let user = JSON.parse(localStorage.getItem('user'));
    
    console.log("AuthHeader ----------------------========================= " + JSON.stringify(user));

    if (user && user.loginToken) {
        return { 'Authorization': 'JWTBearer ' + user.loginToken };
    } else {
        // at any point of time, if auth header is null. Please, logout the user to relogin.
        userService.logout();
        //return {};
    }
}